<template>
  <section
    v-show="hasProductStories"
    :id="`${componentPrefix}-component`"
    :qaid="`${componentPrefix}-component`"
    class="mx-auto px-2 max-w-screen-xxl mb-6"
    data-ga-dimension="dimension11"
    data-ga-dimension-value="Editorial"
  >
    <pdl-carousel carousel-type="ltr" has-navigation>
      <pdl-carousel-slide v-for="productStory in productStories" :key="productStory.id">
        <product-story-card :product-story="productStory" />
      </pdl-carousel-slide>
    </pdl-carousel>
  </section>
</template>

<script>
import ProductStoryCard from '@/components/tabs/overview/ProductStoryCard.vue';
import {mapState} from 'vuex';
import {PdlCarousel, PdlCarouselSlide} from '@pedal/pdl-carousel';

export default {
  components: {
    ProductStoryCard,
    PdlCarousel,
    PdlCarouselSlide,
  },
  data() {
    return {
      componentPrefix: 'product-stories',
    };
  },
  computed: {
    ...mapState('productDetails', ['product']),

    hasProductStories() {
      return !!(this.product && this.product?.productStories?.length);
    },
    productStories() {
      return this.product?.productStories;
    },
  },
};
</script>
